import React, { useEffect, useState } from 'react';
import { errorService } from '../services/errorService';
import type { NetworkError } from '../services/errorService';
import DangerPanel from './DangerPanel'; // Adjust the import based on your actual component path

const NetworkErrorDisplay: React.FC = () => {
  const [errors, setErrors] = useState<NetworkError[]>([]);

  useEffect(() => {
    // Using the simple subscription method instead of rxjs
    const unsubscribe = errorService.subscribe((currentErrors) => {
      setErrors(currentErrors);
    });
    
    // Clean up subscription when component unmounts
    return unsubscribe;
  }, []);

  if (errors.length === 0) {
    return null;
  }

  const dismissError = (id: string) => {
    errorService.clearError(id);
  };

  return (
    <div className="network-errors-container">
      {errors.map(error => (
        <DangerPanel 
          key={error.id}
          fields={[
            { label: 'ID', value: String(error.id) },
            { label: 'Code', value: error.code ? String(error.code) : '' },
            { label: 'Message', value: error.message },
            { label: 'Time', value: error.timestamp.toLocaleTimeString() }
          ]}
          title={`Network Error${error.code ? ` (${error.code})` : ''}`}
          onClose={() => dismissError(error.id)}
        />
      ))}
    </div>
  );
};

export default NetworkErrorDisplay;
